import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Header } from 'semantic-ui-react';
import userId from '../../functions/userid';
import server from '../../functions/server';
import $ from 'jquery';

export default class EditAddress extends React.Component {
  state = {
    open: false,
    address: ""
  };

  handleClose = () => {
    this.props.handleState({editaddress: false});
  };

  handleUpdate = () => {
    let address = this.state.address.trim();
    if (address.length < 1) {
      this.setState({
        message: "Invalid Address"
      });
      return;
    }
    let data = {
      id: this.props.id,
      owner: userId(),
      type: 'address',
      value: address
    }
    console.log(data);
    let context = this;
    $.ajax({
      type: 'POST',
      url: server() + "/shop/update.php",
      data: data,
      beforeSend: function(x) {
          context.setState({
            dimmer: true,
            loadText: "Updating Mobile Number"
          });
      },
      success: function(data, status) {
        let editaddress = true;
        if (data == "1") {
          context.props.updateProps('address', address);
          editaddress = false;
        }
        context.props.handleState({
          dimmer: false,
          loadText: "", editaddress

        });
      },
      error: function(data, status) {
        context.props.handleState({
          dimmer: false,
          loadText: "",
          message: data
        });
      }
    });
  }

  render() {
    if (!this.state.address) {
      this.setState({
        address: this.props.address
      })
    }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Update Address</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter the address
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="descriptionText"
              value={this.state.address}
              onChange={(e) => {this.setState({address: e.target.value, message:""})}}
              fullWidth
            />
            <Header as='h4' color='red'>
              {this.state.message}
            </Header>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleUpdate} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
